import React from "react";
import Image from "../../Tags/Image";

export default function LoaderInfinite({
  heading = "We are on it!",
  description = "Our backend systems are working on this data. Check back here later.",
}) {
  return (
    <div className="text-center overflow-hidden mx-auto max-w-[450px]">
      <Image
        src="/images/ext/companyinfo/techstack-loading.svg"
        alt="Img"
        className="inline-block w-full -mt-16 no-invert"
      />
      <div className="w-8/12 mx-auto">
        <h3 className="text-[16px] font-bold">{heading}</h3>
        <p className="text-gray-600 text-sm mt-1">{description}</p>
        <div className="loader loader_circle loader_purple inline-block mt-4"></div>
      </div>
    </div>
  );
}
